import axios from "axios";
import { getAdminToken } from "../utils/adminAuth";

const addAdminHeader = (config) => {
  const token = getAdminToken();
  if (token) config.headers["X-Admin-Token"] = token;
  return config;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});
api.interceptors.request.use(addAdminHeader);

export const browseAPI = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/browse`,
  timeout: 15000,
});
browseAPI.interceptors.request.use(addAdminHeader);

export default api;
